import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { BannerService } from 'services';
import { ArrowLeftBlack, ArrowRightBlack, UploadIcon, TrashIcon } from 'assets/icons';
import { PaperClip, Button } from 'components';
import { Constants, Globals, checkPermission, Permissions } from 'utils';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Banners extends React.Component<Props> {

	state = {
		banners: [],
		banners_deleted: [],
		principal_index: 0,
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Banners',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await BannerService.admin.get({
			withoutLoading
		});
		this.setState({
			banners: res.banners,
			banners_deleted: [],
			principal_index: 0
		});
	}	

	delete = (item: any) => {
		if (item.id) {
			let banners_deleted: any = [...this.state.banners_deleted];
			banners_deleted.push(item.id);
			let banners: any = [...this.state.banners];
			const index = this.state.banners.findIndex((i: any) => i.id == item.id);
			banners.splice(index,1);
			this.setState({
				banners_deleted,
				banners
			});
		}
		else {
			let banners: any = [...this.state.banners];
			const index = this.state.banners.findIndex((i: any) => i.unique_id == item.unique_id);
			banners.splice(index,1);
			this.setState({
				banners
			});
		}
	}

	save = async () => {
		await BannerService.admin.save({
			hasFile: true,
			principal: this.state.banners.filter((i: any) => i.type == Constants.BANNERS.PRINCIPAL && i.value !== null).map((i: any) => i?.value),
			banners_deleted: JSON.stringify(this.state.banners_deleted)
		});
		Globals.showSuccess("Se han guardado los banners correctamente");
		this.load(true);
	}
	
	render() {
		const principal = this.state.banners.filter((i: any) => i.type == Constants.BANNERS.PRINCIPAL);

		return (
			<div id="admin-banners">
				<p>Puedes cambiar la imagen del banner de la App</p>
				<div className="row">
					<div className="col-md-4">
						<h3>Banner principal</h3>
					</div>
					<div className="col-md-8">
						<div className="container-item">
							<div className="item">
								<button className="btn-arrow" disabled={ this.state.principal_index == 0 } onClick={ () => {
									let principal_index = this.state.principal_index;
									if (principal_index > 0) {
										principal_index--;
										this.setState({
											principal_index
										});
									}
								} }>
									{
										this.state.principal_index > 0 && (
											<img src={ ArrowLeftBlack } />
										)
									}
								</button>
								
								<PaperClip
									disabled={ !checkPermission(Constants.MODULES.BANNERS,'write',this.props.user) }
									value={ null }
									successText={ `` }
									pendingText={ `` }
									exact
									width={ 750 }
									height={ 300 }
									size={ 500 }
									onChange={ async (e: any) => {
										let banners: any = [...this.state.banners];
										if (principal[this.state.principal_index] != null) {
											// @ts-ignore
											const index = this.state.banners.findIndex((i: any) => principal[this.state.principal_index]?.id != null ? i.id == principal[this.state.principal_index]?.id : i.unique_id == principal[this.state.principal_index]?.unique_id);
											banners[index] = {
												// @ts-ignore
												...principal[this.state.principal_index],
												...e.target,
												id: null,
												unique_id: moment().format('YYYYMMDDHHmmss')
											};
											// @ts-ignore
											if (principal[this.state.principal_index]?.id) {
												let banners_deleted: any = [...this.state.banners_deleted];
												// @ts-ignore
												banners_deleted.push(principal[this.state.principal_index]?.id);
												await this.setState({
													banners_deleted
												});
											}
										}
										else {
											banners.push({
												...e.target,
												type: Constants.BANNERS.PRINCIPAL,
												unique_id: moment().format('YYYYMMDDHHmmss')
											});
											await this.setState({
												principal_index: principal.length
											});
										}
										this.setState({
											banners
										});
									} }>
									{
										principal[this.state.principal_index] == null && (
											<div className="container-image">
												<img src={ UploadIcon } />
												<p>Subir Imagen</p>
											</div>
										)
									}
									{
										principal[this.state.principal_index] != null && (
											// @ts-ignore
											<img className="image-selected" src={ principal[this.state.principal_index]?.id != null ? (Constants.BASE_STORAGE + principal[this.state.principal_index]?.file) : principal[this.state.principal_index].dataURL } />
										)
									}
								</PaperClip>

								<button className="btn-arrow" disabled={ this.state.principal_index == 2 } onClick={ () => {
									let principal_index = this.state.principal_index;
									if (principal_index < 2) {
										principal_index++;
										this.setState({
											principal_index
										});
									}
								} }>
									{
										this.state.principal_index < 2 && (
											<img src={ ArrowRightBlack } />
										)
									}
								</button>
							</div>

							<div className="flex-badges">
								<div className="container-badges">
									<div className={ `item-badge ${ this.state.principal_index == 0 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 0
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 1 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 1
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 2 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 2
										});
									} }></div>
								</div>
								<div className="text-right">
									{
										principal[this.state.principal_index] != null && (
											<React.Fragment>
												{
													checkPermission(Constants.MODULES.BANNERS,'delete',this.props.user) && (
														<button className="btn-delete" onClick={ () => this.delete(principal[this.state.principal_index]) }>
															<img src={ TrashIcon } />
															<p>Eliminar</p>
														</button>
													)
												}

												<PaperClip
													disabled={ !checkPermission(Constants.MODULES.BANNERS,'write',this.props.user) }
													value={ null }
													successText={ `` }
													pendingText={ `` }
													exact
													width={ 750 }
													height={ 300 }
													size={ 500 }
													onChange={ async (e: any) => {
														let banners: any = [...this.state.banners];
														if (principal[this.state.principal_index] != null) {
															// @ts-ignore
															const index = this.state.banners.findIndex((i: any) => principal[this.state.principal_index]?.id != null ? i.id == principal[this.state.principal_index]?.id : i.unique_id == principal[this.state.principal_index]?.unique_id);
															banners[index] = {
																// @ts-ignore
																...principal[this.state.principal_index],
																...e.target,
																id: null,
																unique_id: moment().format('YYYYMMDDHHmmss')
															};
															// @ts-ignore
															if (principal[this.state.principal_index]?.id) {
																let banners_deleted: any = [...this.state.banners_deleted];
																// @ts-ignore
																banners_deleted.push(principal[this.state.principal_index]?.id);
																await this.setState({
																	banners_deleted
																});
															}
														}
														else {
															banners.push({
																...e.target,
																type: Constants.BANNERS.PRINCIPAL,
																unique_id: moment().format('YYYYMMDDHHmmss')
															});
															await this.setState({
																principal_index: principal.length
															});
														}
														this.setState({
															banners
														});
													} }>
													<button className="btn-change">
														<img src={ UploadIcon } />
														<p>Cambiar</p>
													</button>
												</PaperClip>
											</React.Fragment>
										)
									}
								</div>
							</div>
						</div>
						<p className="subtitle">Los banner deben ser un archivo 750px por 300px, como máximo de 500kb.</p>
					</div>
					{
						checkPermission(Constants.MODULES.BANNERS,'write',this.props.user) && (
							<div className="col-md-8 offset-md-4 container-submit">
								<Button type="submit" className="btn-submit" onClick={ () => this.save() }>
									Guardar
								</Button>
							</div>
						)
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Banners);